import React, { useState, useEffect, useRef, useCallback } from "react";
import "./index.less";
import { Checkbox, DatePicker, Pagination, Popover } from "antd";
import { useNavigate } from "react-router-dom";
import { request } from "@/utils/request"
import NavigationBar from "@/components/NavigationBar";
import search from '@/assets/search.png'
import tabselect from '@/assets/tabselect.png'
import eat from '@/assets/eat.png'
import address from '@/assets/address.png'
import noSearch from '@/assets/noSearch.png'
import sort1 from '@/assets/sort1.png'
import sort2 from '@/assets/sort2.png'
import sort3 from '@/assets/sort3.png'
import day from '@/assets/day.png'
import night from '@/assets/night.png'
import Config from "@/config/config";
import honor from '@/assets/honor.png'
import restaurant from '@/assets/restaurant.png';
import {
    DeleteOutlined,
    DownOutlined,
    EnvironmentOutlined,
    SearchOutlined,
    UpOutlined
} from '@ant-design/icons';
import moment from "moment";

export default function Canteen() {
    const navigate = useNavigate();
    const [recommend, setRecommend] = useState([])
    const [page, setPage] = useState(1)
    const [regionList, setRegionList] = useState([]);
    const [regionInfo, setRegionInfo] = useState([]);
    const [cateList, setCateList] = useState([]);
    const [isOpen, setIsOpen] = useState('none');
    const [currentType, setCurrentType] = useState(0);
    const [currentCity, setCurrentCity] = useState(JSON.parse(sessionStorage.getItem('ct'))?.currentCity || 0);
    const [currentRegion, setCurrentregion] = useState(JSON.parse(sessionStorage.getItem('ct'))?.currentRegion || 0);
    const [currentHonor, setCurrentHonor] = useState(0);
    const [honorList, setHonorList] = useState([]);
    const [tagList, setTagList] = useState([])
    const [params, setParams] = useState(JSON.parse(sessionStorage.getItem('ct'))?.params || {
        region_id: '',
        category_id: '',
    })
    const [openSet, setOpenSet] = useState({
        region: false,
        type: false,
        tag: false,
        honor: false,
    })
    const [selectVal, setSelectVal] = useState(JSON.parse(sessionStorage.getItem('ct'))?.selectVal || {})
    const [perPage, setPerPage] = useState(12);
    const [total, setTotal] = useState(0)
    const listRef = useRef(null);
    const [searchHistory, setSearchHistory] = useState(JSON.parse(localStorage.getItem('ctHis')) || []);
    const [lastRegionInfo, setLastRegionInfo] = useState([]);
    const [currentLastregion, setCurrentLastregion] = useState(JSON.parse(sessionStorage.getItem('ct'))?.currentLastregion || 0);
    const [openDate,setOpenDate]=useState(false)
    const fetchData = async (page, perPage, name = '', first_region_id = '', region_id = '', category_id = '', honor_ids = '', tag_ids = '', date = '', member = '') => {
        try {
            let url = '/restaurant/list' + `?page=${page}&per-page=${perPage}`;
            if (name) {
                url += "&name=" + name
            }
            if (first_region_id) {
                url += "&first_region_id=" + first_region_id
            }
            if (region_id) {
                url += "&region_id=" + region_id
            }
            if (category_id) {
                url += "&category_id=" + category_id
            }
            if (honor_ids) {
                url += "&honor_ids=" + honor_ids
            }
            if (tag_ids) {
                url += "&tag_ids=" + tag_ids
            }
            if (date) {
                url += "&date=" + date
            }
            if (member) {
                url += "&member=" + member
            }
            const response = await request.get(url);
            let data = response.data
            setRecommend(data)
            setTotal(response._meta.totalCount)
            if (currentDate.current == null) { params.date = '' }
            sessionStorage.setItem("ct", JSON.stringify({
                selectVal,
                params,
                currentDate: currentDate.current,
                currentCity,
                currentRegion,
                changeLastRegion
            }))
            if (name) {
                // 过滤掉 searchHistory 中已存在的搜索词，然后将新的搜索词添加到数组开头
                const newSearchHistory = [name, ...searchHistory.filter(item => item !== name)];
                setSearchHistory(newSearchHistory);
                localStorage.setItem('ctHis', JSON.stringify(newSearchHistory));
            }

        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    useEffect(() => {
        // listRef.current.scrollIntoView({ behavior: "smooth" })
        if (listRef.current) {
            window.scrollTo(0, 0)
        }

    }, [recommend])


    const pageChange = (e, v) => {

        setPage(e)
        setPerPage(v)
        fetchData(e, v)
    };

    const doSearch = (val) => {
        // fetchData(0, perPage, val)
        console.log(val)
        // fetchData(0,perPage,val)
        navigate('/search?name=' + val)
    }
    const changeCity = (val, index) => {
        setPage(1)
        selectVal.region = val.name
        params.first_region_id = val.id
        params.region_id = ''
        setParams({ ...params })
        setSelectVal({ ...selectVal })
        setCurrentCity(index)
        setCurrentregion(0)
        setRegionInfo(regionList[index]?.children)
        setLastRegionInfo([])
        if (index == 0) {
            setOpenSet({ ...openSet })
            setIsOpen('none')
        }
        openSet.region = false
        fetchData(1, perPage, params.name, val.id, '', params.category_id, params.honor_ids, params.tag_ids, params.date, params.member);
    }
    const changeRegion = (val, index) => {
        setPage(1)
        selectVal.region = val.name
        setSelectVal({ ...selectVal })
        setCurrentLastregion(0)
        setLastRegionInfo(val?.children)
        setCurrentregion(index)
        if (val.id == '') {
            params.region_id = ''
            setParams({ ...params })
            fetchData(1, perPage, params.name, params.first_region_id, val.id, params.category_id, params.honor_ids, params.tag_ids, params.date, params.member);
        } else {
            params.region_id = val.id
            fetchData(1, perPage, params.name, params.first_region_id, val.id, params.category_id, params.honor_ids, params.tag_ids, params.date, params.member);
        }
        openSet.region = false
        setOpenSet({ ...openSet })
        setIsOpen('none')

    }
    const changeLastRegion = (val, index) => {
        console.log(lastRegionInfo, 'laa', val)
        selectVal.region = val.name
        setSelectVal({ ...selectVal })
        setCurrentLastregion(index)
        openSet.region = false
        setOpenSet({ ...openSet })
        if (val.first_region_id) {
            params.region_id = val.first_region_id
        }
        params.region_id = val.id
        setParams({ ...params })
        fetchData(1, perPage, params.name, '', val.id || val.first_region_id, params.category_id, params.honor_ids, params.tag_ids, params.date, params.member);
    }
    const changeType = (val, index) => {
        setPage(1)
        selectVal.type = val.name
        setSelectVal({ ...selectVal })
        setCurrentType(index)
        params.category_id = val.id
        setParams({ ...params })
        openSet.type = false
        setOpenSet({ ...openSet })
        fetchData(1, perPage, params.name, params.first_region_id, params.region_id, val.id, params.honor_ids, params.tag_ids, params.date, params.member);
        setIsOpen('none')
    }
    const changeHonor = (val, index) => {
        setPage(1)
        selectVal.honor = val.name
        setSelectVal({ ...selectVal })
        setCurrentHonor(index)
        params.honor_ids = val.id
        setParams({ ...params })
        openSet.honor = false
        setOpenSet({ ...openSet })
        fetchData(1, perPage, params.name, params.first_region_id, params.region_id, params.category_id, val.id);
        setIsOpen('none')
    }
    const getRegionList = async () => {
        const reponse = await request.get('restaurant/region-list?page=1&per-page=100', {});
        reponse.data.unshift({
            children: [],
            id: "",
            name: "全部",
        })
        let temp = reponse.data
        temp = temp.map((v, i) => {
            let child = v.children;
            child.first_region_id = v.id;
            if (i > 0) {
                child?.unshift({
                    id: '',
                    name: `全${v.name}`,
                    first_region_id: v.id,
                    children: [] // 新增一级的空数组
                });
            }
            // 处理新增的一级
            child = child.map((subV, subI) => {
                if (subI > 0) {
                    subV.children?.unshift({
                        id: '',
                        name: `全${subV.name}`,
                        first_region_id: subV.id
                    });
                }
                return subV;
            });
            return v;
        });
        setRegionList(temp)
        setRegionInfo(temp[0].children)
        setLastRegionInfo(temp[0]?.children[0]?.children);
        if (params?.member) {
            setSelectMum(params.member)
        }
    }
    const getCateList = async () => {
        // restaurant/category-list
        const reponse = await request.get('restaurant/category-list?page=1&per-page=100', {});
        reponse.data.unshift({
            id: "",
            name: "全部"
        })
        console.log(selectVal, 'selectVal')
        if (selectVal?.type) {
            reponse.data.map((v, i) => {
                if (v.name == selectVal.type) {
                    setCurrentType(i)
                }
            })
        }
        setCateList(reponse.data)
    }
    const getHonorist = async () => {
        const reponse = await request.get('restaurant/honor-list?page=1&per-page=100', {});
        reponse.data.unshift({
            id: "",
            name: "全部"
        })
        if (selectVal?.honor) {
            reponse.data.map((v, i) => {
                if (v.name == selectVal.honor) {
                    setCurrentHonor(i)
                }
            })
        }
        setHonorList([...reponse.data])


    }
    const getTagList = async () => {
        const reponse = await request.get('restaurant/tag-list?page=1&per-page=100', {});
        reponse.data.map(v => {
            if (params.tag_ids?.split(',').includes(v.id)) {
                v.checked = true
            } else {
                v.checked = false
            }
        })
        setTagList([...reponse.data])
    }
    useEffect(() => {
        sessionStorage.setItem("mbx", "canteen")
        getRegionList()
        getCateList()
        getHonorist()
        getTagList()
        fetchData(page, perPage, params.name, params.first_region_id, params.region_id, params.category_id, params.honor_ids, params.tag_ids, params.date, params.member);

    }, []);
    const currentDate = useRef((JSON.parse(sessionStorage.getItem('ct'))?.currentDate && moment(JSON.parse(sessionStorage.getItem('ct'))?.currentDate)) || null)
    const selectDate = (date, dateString) => {

        params.date = dateString
        setParams({ ...params })
        currentDate.current = date
        fetchData(page, perPage, params.name, params.first_region_id, params.region_id, params.category_id, params.honor_ids, params.tag_ids, dateString, params.member);

    }
    const [selectMum, setSelectMum] = useState('')
    const selectMember = (value) => {
        setSelectMum(value)
    }
    const sureSelect = () => {
        let selectList = tagList.filter(item => item.checked === true).map(item => item.id)
        params.tag_ids = selectList?.join(',')
        openSet.tag = false
        setOpenSet({ ...openSet })
        setParams({ ...params })
        fetchData(page, perPage, params.name, params.first_region_id, params.region_id, params.category_id, params.honor_ids, selectList?.join(','));
        setIsOpen('none')
    }
    const delNullSelect = () => {
        tagList.map(item => {
            return item.checked = false
        })
        openSet.tag = false
        setOpenSet({ ...openSet })
        setTagList([...tagList])
        params.tag_ids = ''
        setParams({ ...params })
        sessionStorage.setItem("ct", JSON.stringify({
            selectVal,
            params,
            currentDate,
            currentCity,
            currentRegion,
            changeLastRegion
        }))
        fetchData(page, perPage, params.name, params.first_region_id, params.region_id, params.category_id, params.honor_ids, '');
    }
    const resetSearchHistory = () => {
        localStorage.removeItem('ctHis')
        setSearchHistory([])
    }
    const handleHistorySearch = (item) => {
        params.name = item
        setParams({ ...params })
        fetchData(page, perPage, item, params.first_region_id, params.region_id, params.category_id, params.honor_ids, params.tag_ids);
    }
    const SearchHistoryComp = () => {
        return (
            <>
                <div className="search-history-box">
                    <div className="search-history-box-item-head">
                        <div className="search-history-box-item-head-left">历史记录</div>
                        <div className="search-history-box-item-head-right"
                            onClick={resetSearchHistory}
                        >
                            <DeleteOutlined /></div>
                    </div>
                    <div className="search-history-box-content">
                        {searchHistory.map((item) => {
                            return (
                                <div className="search-history-list-item" onClick={() => {
                                    handleHistorySearch(item)
                                }}>
                                    <div className="search-history-list-item-icon">
                                        <SearchOutlined />
                                    </div>
                                    <span className="search-history-item-text">
                                        {item}
                                    </span>
                                </div>
                            )
                        })}
                    </div>

                </div>
            </>
        )
    }
    // 定义一个变量用于存储定时器 ID
    let timeoutId = null;

    const nameSearch = (e) => {
        setPage(1)
        params.name = e.target.value.trim();
        setParams({ ...params });
        // 清除之前的定时器
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        // 设置新的定时器，在用户输入完成 500ms 后执行搜索操作
        timeoutId = setTimeout(() => {
            fetchData(1, perPage, e.target.value, params.first_region_id, params.region_id, params.category_id, params.honor_ids, params.tag_ids, params.date, params.member);
        }, 1000);
    };
    return (
        <div className="canteen" ref={listRef} onClick={() => {
            console.log('lijiao')
            openSet.region = false
            openSet.type = false
            openSet.honor = false
            openSet.date = false
            openSet.tag = false
            setIsOpen(openSet.type ? 'block' : 'none')
            setOpenSet({ ...openSet })
        }}>
            <NavigationBar showNavRight={true} showNavTabs={true} showSearch={true}
                onSearchChange={doSearch}></NavigationBar>
            <div className="canteen-heart">
                <div className="search-content">
                    <div className="search-title">
                        <div>筛选餐厅</div>
                        <div style={{ position: 'relative' }}>
                            <img src={tabselect} alt="" className='tabselectIcon' onClick={(e) => {
                                e.stopPropagation();
                                openSet.tag = !openSet.tag;
                                openSet.date = false
                                openSet.region = false
                                openSet.honor = false
                                openSet.type = false
                                setIsOpen(openSet.date ? 'block' : 'none')
                                setOpenSet({ ...openSet })
                            }} />
                            {
                                openSet.tag && <div className='select-mask-tag' onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault(); // 可选：阻止默认行为
                                }}>
                                    <div className='tag-select-tab'>
                                        {
                                            tagList?.map((v, i) => {
                                                return <div key={i} className="tab-content-item">
                                                    <div className="tab-content-item-name">{v.name}</div>
                                                    <Checkbox
                                                        checked={v.checked}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            tagList[i].checked = e.target.checked
                                                            setTagList([...tagList])
                                                        }}
                                                    />
                                                </div>
                                            })

                                        }
                                    </div>
                                    <div className="tab-content-item-btn">
                                        <div className="tab-cancel-btn" onClick={delNullSelect}>清除</div>
                                        <div className="tab-select-btn" onClick={sureSelect}>筛选</div>
                                    </div>
                                </div>
                            }
                        </div>

                    </div>


                    <div className='search-tool'>
                        <Popover placement="bottom" content={SearchHistoryComp} title=""
                            style={{ borderRadius: "8px" }}>
                            <div className='search-input'>
                                <img src={search} alt="" className='searchIcon' />
                                <input value={params.name} placeholder="搜索餐厅名称" onInput={(e) => nameSearch(e)} />
                            </div>
                        </Popover>
                        <div className='search-select'>
                            <div className='select-moudle-canteen'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openSet.date = !openSet.date
                                    openSet.region = false
                                    openSet.honor = false
                                    openSet.type = false
                                    openSet.tag = false

                                    setIsOpen(openSet.date ? 'block' : 'none')
                                    setOpenSet({ ...openSet })
                                }}>
                                <DatePicker
                                    picker={null}
                                    value={currentDate.current}
                                    placeholder="日期 · 人数"
                                    format={"YYYY-MM-DD"}
                                    open={openDate}
                                    renderExtraFooter={() =>
                                        <div>
                                            <div>人数</div>
                                            <div className="select-member-moudel">
                                                {
                                                    [1, 2, 3, 4, 5, 6, 7, 8].map(v => {
                                                        return <div className={selectMum == v ? 'select-member-active' : 'select-member'} onClick={() => {
                                                            params.member = v
                                                            setSelectMum(v)
                                                            setParams({ ...params })
                                                        }} key={v}>{v}人</div>
                                                    })
                                                }
                                            </div>
                                            <div className="btnBox">
                                                <div className="delBtn" onClick={() => {
                                                    setPage(1)
                                                    params.date = ''
                                                    params.member = ''
                                                    currentDate.current = null
                                                    openSet.date = false
                                                    setSelectMum('')
                                                    setOpenSet({ ...openSet })
                                                    setParams({ ...params })
                                                    fetchData(1, perPage, params.name, params.first_region_id, params.region_id, params.category_id, params.honor_ids, params.tag_ids, '', '');
                                                    setOpenDate(false)
                                                }}>清除</div>
                                                <div className="selectBtn" onClick={() => {
                                                    setPage(1)
                                                    openSet.date = false
                                                    setOpenSet({ ...openSet })
                                                    fetchData(1, perPage, params.name, params.first_region_id, params.region_id, params.category_id, params.honor_ids, params.tag_ids, params.date, selectMum);
                                                    setIsOpen('none')
                                                    setOpenDate(false)
                                                }}>筛选</div>
                                            </div>
                                        </div>
                                    }
                                    onClick={() => {setOpenDate(true) }}
                                    suffixIcon={<DownOutlined />}
                                    onChange={selectDate}
                                    needConfirm={true}
                                />


                            </div>
                            <div className='select-moudle-canteen'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openSet.region = !openSet.region
                                    openSet.honor = false
                                    openSet.type = false
                                    setIsOpen(openSet.region ? 'block' : 'none')
                                    setOpenSet({ ...openSet })
                                }}>
                                <div className='select-item'>
                                    <div className='select-label'>
                                        <img src={address} alt="" className='icon' />
                                        <div className="select-type">{selectVal.region || '区域'}</div>
                                    </div>

                                    {
                                        openSet.region ? <UpOutlined /> : <DownOutlined />
                                    }
                                </div>
                                {
                                    openSet.region && <div className='select-mask-region'>
                                        <div className='left'>
                                            {
                                                regionList?.map((v, i) => {
                                                    return <div
                                                        onClick={() => { changeCity(v, i) }}
                                                        className={`city-item ${currentCity == i ? 'active' : ''}`}
                                                    >{v.name}</div>
                                                })
                                            }
                                        </div>
                                        <div className='middle'>
                                            <div >
                                                {
                                                    regionInfo?.map((v, i) => {
                                                        return <div
                                                            className={`city-item ${currentRegion == i ? 'active' : ''}`}
                                                            onClick={() => { changeRegion(v, i) }}
                                                        >{v.name}</div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className='right'>
                                            <div >{
                                                lastRegionInfo?.map((v, i) => {
                                                    return <div
                                                        className={`region-item ${currentLastregion == i ? 'active' : ''}`}
                                                        onClick={() => { changeLastRegion(v, i) }}
                                                    >{v.name}</div>
                                                })
                                            }</div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className='select-moudle-canteen'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openSet.region = false
                                    openSet.honor = false
                                    openSet.type = !openSet.type
                                    setIsOpen(openSet.type ? 'block' : 'none')
                                    setOpenSet({ ...openSet })
                                }}>
                                <div className='select-item'>
                                    <div className='select-label'>
                                        <img src={eat} alt="" className='icon' />
                                        <div className="select-type">{selectVal.type || '餐厅类型'}</div>
                                    </div>
                                    {
                                        openSet.type ? <UpOutlined /> : <DownOutlined />
                                    }
                                </div>
                                {
                                    openSet.type && <div className='select-mask-type'>
                                        <div className='all'>
                                            <div >{
                                                cateList?.map((v, i) => {
                                                    return <div
                                                        className={`all-item ${currentType == i ? 'active' : ''}`}
                                                        onClick={() => { changeType(v, i) }}
                                                    >{v.name}</div>
                                                })
                                            }</div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className='select-moudle-canteen'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openSet.region = false
                                    openSet.type = false
                                    openSet.honor = !openSet.honor
                                    setIsOpen(openSet.honor ? 'block' : 'none')
                                    setOpenSet({ ...openSet })
                                }}>
                                <div className='select-item'>
                                    <div className='select-label'>
                                        <img src={honor} alt="" className='icon' />
                                        <div className="select-type">{selectVal.honor || '荣誉奖项'}</div>
                                    </div>
                                    {
                                        openSet.honor ? <UpOutlined /> : <DownOutlined />
                                    }
                                </div>
                                {
                                    openSet.honor && <div className='select-mask-type'>
                                        <div className='all'>
                                            <div >{
                                                honorList?.map((v, i) => {
                                                    return <div
                                                        className={`all-item ${currentHonor == i ? 'active' : ''}`}
                                                        onClick={() => { changeHonor(v, i) }}
                                                    >{v.name}</div>
                                                })
                                            }</div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
                <div className="type-rcmdlist" >
                    {/* <div className="rcmdlist-title" >推荐餐厅</div> */}
                    <div className="rcmdlist-content">
                        {
                            recommend?.length > 0 ? <>
                                {
                                    recommend?.map((item, idx) => {
                                        return (
                                            // 如果你想在 style 属性中添加更多判断，可以使用三元运算符或者对象合并的方式。以下是一个修改后的代码示例，它根据 idx 是否为 4 的倍数来设置 marginRight 属性：
                                            <div key={item.id} className='rcmdlist-items' onClick={(e) => {
                                                e.stopPropagation();
                                                navigate('/detail?id=' + item.id)
                                            }
                                            }
                                            >
                                                <img
                                                    objectFit="cover"
                                                    src={Config.imgPrefix + item.cover[0]}
                                                    className="item-cover" alt="" />
                                                <div className="info">
                                                    <div className="name">
                                                        {
                                                            idx === 0 && <img src={sort1} className="sort" />
                                                        }
                                                        {
                                                            idx === 1 && <img src={sort2} className="sort" />
                                                        }
                                                        {
                                                            idx === 2 && <img src={sort3} className="sort" />
                                                        }
                                                        {
                                                            idx > 2 && <div className="sort-num">{idx + 1}</div>
                                                        }
                                                        <div className="name-txt">{item.name}</div>
                                                    </div>
                                                    <div className="honors">
                                                        {
                                                            item.honors?.map(v => {
                                                                return <img className='honorLog' src={Config.imgPrefix + v.cover} />
                                                            })
                                                        }
                                                    </div>
                                                    {
                                                        !!item.name_en && <div className="name_en">{item.name_en}</div>
                                                    }

                                                    <div className="city">
                                                        <div style={{ fontSize: "12px", display: 'flex', alignItems: 'center', marginRight: '10px' }}> <img src={restaurant} className="icon" alt="" style={{ width: '16px', height: '16px', marginRight: '5px' }} /> {item.category_names.join('·')}</div>

                                                        {
                                                            item.region && <div><EnvironmentOutlined style={{ marginRight: '5px' }} />{item.region}</div>
                                                        }

                                                    </div>
                                                    <div className="price">
                                                        {
                                                            !!item.lunch_price && <div className="lunch_price price-item"><img src={day} alt="" className="icon" /> <div>JPY {item.lunch_price} ~</div></div>
                                                        }
                                                        {
                                                            !!item.supper_price && <div className="supper_price price-item"><img src={night} alt="" className="icon" /> <div>JPY {item.supper_price} ~</div></div>
                                                        }
                                                    </div>
                                                    <div className="notification" dangerouslySetInnerHTML={{ __html: item.notification }}>
                                                        {/* {item.notification} */}
                                                    </div>
                                                </div>

                                            </div>
                                        )
                                    })
                                }
                            </> :
                                <div className='no-data'>
                                    <img src={noSearch} alt="" srcset="" className='searchIcon' />
                                    <div className='no-data-tip'>没有搜索结果</div>
                                </div>
                        }
                    </div>
                    <div className="pagination-box">
                        <Pagination
                            className='main-pagination'
                            total={total}
                            pageSize={perPage}
                            pageSizeOptions={[12, 24, 36, 48]}
                            onChange={pageChange}
                            showQuickJumper
                            showTotal={(total) => `共${total}条`}
                            current={page}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
